// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles_loading__8XJJ5","contentWrapper":"styles_contentWrapper__EfRbt","pricingOffersWrapper":"styles_pricingOffersWrapper__MpRF_"};